// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"952f37ab","2487":"952f37ab","4096":"952f37ab","5281":"952f37ab","5614":"952f37ab","6346":"952f37ab","9640":"2103c771"}[chunkId] + ".chunk.css";
};